import { AUTHENTICATION_FLOW_STATE, AuthenticationFlowState } from '~/src/stores/authentication-flow'
import { useEoState } from '~/src/hooks/useEoState'
import { useEffect } from 'react'
import { UseAuthenticationFlowDialogsReturnType } from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import { useResetPassword } from '~/src/hooks/auth/useResetPassword'
import AuthRoutesEnum from '~/src/router/enums/auth.enum'
import RoutesEnum from '~/src/router/enums/routes.enum'
import { useFirmPathResolver } from '~/src/hooks/router/useFirmPathResolver'
import { useRouterPush } from '~/src/hooks/router/useRouterPush'

interface ReturnsType {
  onSubmit(): Promise<void>,
}

interface Props extends Pick<UseAuthenticationFlowDialogsReturnType, 'goToStep' | 'restart'> {}

const useAuthenticationFlowResetPasswordOnSubmit = ({ goToStep, restart }: Props): ReturnsType => {
  const { errors, loading, resetPassword } = useResetPassword()
  const { resolve } = useFirmPathResolver()
  const { push } = useRouterPush()
  const [ authenticationFlowState, setAuthenticationFlowState ] = useEoState<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)

  const onSubmit = async (): Promise<void> => {
    if (!authenticationFlowState.password || !authenticationFlowState.confirmPassword) {
      return
    }

    const url: URL = new URL(location.href)
    const token = url.searchParams.get('token')
    const timestamp = url.searchParams.get('timestamp')

    const response = await resetPassword(
      {
        password: authenticationFlowState.password,
        confirmPassword: authenticationFlowState.confirmPassword
      },
      decodeURIComponent(token!),
      decodeURIComponent(timestamp!)
    )

    if (!response) {
      return
    }

    if (location.href.includes(AuthRoutesEnum.RESET_PASSWORD)) {
      push(resolve(RoutesEnum.FIRM_HOME))
      restart()
    } else {
      goToStep(AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_LOGIN)
    }
  }

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      isLoading: loading
    }))
  }, [ loading ])

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      errors: errors
    }))
  }, [ errors ])

  return {
    onSubmit
  }
}

export default useAuthenticationFlowResetPasswordOnSubmit
